import { HeadlineTypeEnum } from "../../assets/utils/enums/headline";
import { ThemeTypeEnum } from "../../assets/utils/validation/types";
import { BodyDiv } from "../../components/components-style";
import AppLayout, { MainBody } from "../../components/layout/app/layout";
import Headline from "../../components/ui/headline";

import settingsItems from "../../assets/utils/data/items";
import AccountItem from "../../components/ui/account-settings-item";
import styled from "styled-components";
import { MediumText } from "../../components/typography";
import { COLORS } from "../../assets/utils/enums/colors";
import { useState } from "react";
import { Button } from "../../components/ui/button";
import exitIcon from "../../assets/images/icons/exit-icon.svg";
import CustomToast from "../../components/ui/custom-toast";
import toast from "react-hot-toast";
import { ToastTypeEnum } from "../../assets/utils/enums/toast";
import { API_URL_AUTH, API_URL_USER } from "../../constants";
import { useDispatch } from "react-redux";
import { clearAccessToken } from "../../assets/store/auth";
import { authFetch } from "../../api/authFetch";
import { ActionsEnum } from "../../assets/utils/enums/settings";
import { Outlet, useNavigate } from "react-router-dom";
import { ModalWindowType } from "../../components/ui/modal-window";

export default function SettingsPage() {
  const [isChangedFields, setIsChangedState] = useState<boolean>(false);
  const [loaderState, setLoaderState] = useState<boolean>(false);

  const [modalWindowSettings, setModalWindowSettings] =
    useState<ModalWindowType>({
      isOpen: false,
      onConfirm: () => {},
      onCancel: () => {},
    });

  const dispatch = useDispatch();

  const navigate = useNavigate();

  async function logout() {
    setLoaderState(true);
    const responce = await fetch(`${API_URL_AUTH}/logout`, {
      method: "POST",
      credentials: "include",
    });
    if (responce.status === 200) {
      dispatch(clearAccessToken());
      setTimeout(() => {
        toast((t) => (
          <CustomToast
            t={t}
            type={ToastTypeEnum.INFO}
            text={"Ви вийшли з акаунту"}
          />
        ));
        setLoaderState(false);
      }, 150);

      setModalWindowSettings((prev) => ({ ...prev, isOpen: false }));
      navigate("/sign-in");
    }
  }

  async function deleteFunc() {
    const response = await authFetch(`${API_URL_USER}/delete`, {
      method: "DELETE",
      credentials: "include",
    });

    if (response.ok) {
      dispatch(clearAccessToken());
      toast((t) => (
        <CustomToast
          t={t}
          type={ToastTypeEnum.INFO}
          text={"Ви видалили акаунт."}
        />
      ));
    }

    setModalWindowSettings((prev) => ({ ...prev, isOpen: false }));
    navigate("/sign-in");
  }

  function deleteActionWindow() {
    setModalWindowSettings({
      isOpen: true,
      onConfirm: deleteFunc,
      onCancel: () =>
        setModalWindowSettings((prev) => ({
          ...prev,
          isOpen: false,
        })),
      action: ActionsEnum.DELETE,
    });
  }

  return (
    <AppLayout
      className=""
      blockType="settings"
      loaderState={loaderState}
      modalWindow={modalWindowSettings}
    >
      <Headline
        headline={HeadlineTypeEnum.SETTINGS}
        theme={ThemeTypeEnum.LIGHT}
      />
      <MainBody className="align-items-stretch">
        <BodyDiv
          data-class="settings-bar"
          className="d-flex flex-column justify-content-between"
        >
          <div className="">
            {settingsItems.map((item) => (
              <AccountItem
                key={item.id}
                item={item}                
                isChangedFields={isChangedFields}
              />
            ))}
          </div>
          <Button
            bgcolor={"transparent"}
            txtcolor={COLORS.secondary1}
            brcolor={"transparent"}
            type="large"
            width="auto"
            className="d-flex align-items-center justify-content-start gap-2"
            onClick={() => {
              setModalWindowSettings({
                isOpen: true,
                onConfirm: logout,
                onCancel: () =>
                  setModalWindowSettings((prev) => ({
                    ...prev,
                    isOpen: false,
                  })),
                action: ActionsEnum.EXIT,
              });
            }}
          >
            <img src={exitIcon} alt="exit-icon" />
            <MediumText>Вийти</MediumText>
          </Button>
        </BodyDiv>
        
        <Outlet
          context={{
            setLoaderState,
            deleteActionWindow,
            isChangedFields,
            setIsChangedState,
          }}
        />
      </MainBody>
    </AppLayout>
  );
}

export const GeneralItemBlock = styled.div`
  display: flex;
  flex-grow: 1;
  gap: 20px;
  padding-left: 30px;
  align-items: center;
  ${Button} {
    flex: 0 1 auto;
  }
`;

export const Block = styled.div`
  &[data-type="general-item"] {
    padding: 24px 4px;
    border-bottom: 2px solid ${COLORS.gray};
    img {
      width: 26px;
      height: 26px;
    }
    span {
      display: flex;
      align-items: center;
      gap: 12px;
      color: ${COLORS.secondary1};
      min-width: 30%;
    }
  }

  ${Button} {
    margin: 0;
    &.text {
      cursor: auto;
      &:active {
        transform: scale(1);
      }
    }
    img {
      width: 26px;
      height: 26px;
    }
  }
`;
